import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-new-loader',
  templateUrl: './new-loader.component.html',
  styleUrls: ['./new-loader.component.scss']
})
export class NewLoaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
